import * as styles from './MenuItems.module.css'

function MenuItems({ children, className = styles.MenuItems }) {
  return (
    <div className={className}>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default MenuItems
